import styled from 'styled-components'

export const MainContainer = styled.div`
  display: grid;
  grid-template-columns: 0.3fr 0.7fr;
  gap: ${props => props.theme.spacing.sp16};
`
